const RequiredFieldDecorator =
    function () {
        return function (field) {
            if ((field.validator) && (field.validator.validation))
            {
              let decorator = field.validator.validation.includes('required') || field.validator.validation.includes('Required')
                  || field.Label == 'Activity Date'
                  || field.Label == 'Location' ? '* ' : '';
  
              return decorator + field.Label;
            }
            else
            {
                return field.Label;
            }
        }
    };

export default RequiredFieldDecorator;
